export default __webpack_public_path__ + "static/media/3-Beilstein_symposium-GlyGen-2019.06.27.13f0d643.pdf";